Ext.define('SA.view.sidebar.data.DataFacetIncomeRange', {
    alias: 'widget.data-facet-income-range',
    extend: 'SA.view.sidebar.data.DataFacetRange',

    hidden: true,
    inputFormat: '$%d',
    inputMask: /[\d$,]/,
    maxInputLength: 10,
    title: 'Income Range',

    countryProperties: {
        CAN: {
            labelIncrement: 75000,
            limits: [0, 300000],
            stepIncrement: 5000,
            tickIncrement: 25000
        },

        USA: {
            labelIncrement: 125000,
            limits: [0, 500000],
            stepIncrement: 5000,
            tickIncrement: 62500
        }
    },

    initComponent() {
        Object.assign(this, this.countryProperties[this.country]);

        this.callParent();
    },

    formatLabel(value) {
        if (value === 0) {
            return '$0';
        }

        return `$${value / 1000}K`;
    }
});